<template>
<div class="chapter">
<div class="inner_page">
<p class="ctc2a" id="ch1a">Acknowledgments</p>
<p class="tx1" id="d7e60">Thanks to my husband, Doug, for his help and encouragement during this endeavor. Thanks also to my agent, Barb Doyen, for her clear head and calm nature. My editor, Kate Burgo, deserves thanks for her patience and belief in me. And thanks to my father-in-law and his wife, T.E. and Dagmar, for supporting me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// auth_ISBNXXXXXXXXX_epub_c6_r1.vue?044044fe